import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Row,
  Col,
} from 'reactstrap'
import styled from 'styled-components'
import { generateButton } from '../helpers/button'

export const ConfirmCancel = (props) => {
  const { open } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => props.toggle() }
      >
        <HeaderForm toggle={ () => props.toggle() }>
          <HeadLabel>Cancel Request Confirmation</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <TextLabel>Are you sure you want to cancel this request?</TextLabel>
          <br />
          <TextLabel>Remarks (Optional)</TextLabel>
          <Row>
            <Col>
              <textarea
                style={ { width: '100%' } }
                placeholder='Tell us a reason why you want to cancel this request'
                onBlur={ (e) => props.handleRemark(e) }
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { generateButton('cancel', (type) => props.clickCancelButton(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

ConfirmCancel.propTypes = {
  clickCancelButton: PropTypes.func,
  handleRemark: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
}
ConfirmCancel.defaultProps = {
  clickCancelButton: () => {},
  handleRemark: () => {},
  toggle: () => {},
  open: false,
}

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/form/confirm-cancel.js